import styled from 'styled-components';
import { withPrefix } from 'gatsby';

export const MainSectionStyled = styled.section`
  max-width: 1200px;
  width: 100%;
  margin: 0 auto;
  padding: 24px 24px 80px;

  @media screen and (max-width: 900px) {
    padding: 16px 16px 64px;
  }
  
  .kanula{
    background: linear-gradient(135deg, #00BCD4 0%, #00E5FF 100%);
    -webkit-background-clip: text;
    -webkit-text-fill-color: transparent;
    background-clip: text;
    font-weight: 700;
  }

  .ldoa {
    display: grid;
    justify-content: center;
  }
`;

export const MainStyled = styled.main`
  margin: 93px 0;

  @media screen and (max-width: 800px) {

  }
`;

export const HeaderStyled = styled.nav`
  position: sticky;
  top: 0;
  z-index: 50;
  background: rgba(11, 18, 32, 0.85);
  backdrop-filter: blur(12px);
  -webkit-backdrop-filter: blur(12px);
  color: #e5e7eb;
  border-bottom: 1px solid rgba(0, 188, 212, 0.15);
  box-shadow: 0 4px 24px rgba(0, 0, 0, 0.3);

  display: grid;
  grid-template-columns: 1fr 3fr 1fr;
  align-items: center;
  grid-gap: 60px;
  padding: 16px 24px;
  transition: all 0.3s ease;

  @media screen and (max-width: 800px) {
    grid-template-columns: 1fr;
    grid-gap: 14px;
    text-align: center;
    padding: 14px 16px;
  }
`;

export const LogoStyled = styled.div`
  font-size: 24px;
  font-weight: 700;
  letter-spacing: 0.5px;
  background: linear-gradient(135deg, #ffffff 0%, #e0e0e0 100%);
  -webkit-background-clip: text;
  -webkit-text-fill-color: transparent;
  background-clip: text;

  span {
    font-size: 11px;
    margin-left: 8px;
    background: linear-gradient(135deg, #00BCD4, #00E5FF);
    color: #0a1628;
    padding: 3px 8px;
    border-radius: 999px;
    font-weight: 700;
    -webkit-background-clip: initial;
    -webkit-text-fill-color: initial;
    background-clip: initial;
    box-shadow: 0 2px 8px rgba(0, 188, 212, 0.3);
  }
`;

export const MenuStyled = styled.ul`
  display: grid;
  grid-template-columns: repeat(4, minmax(0, 1fr));
  gap: 10px;
  align-items: center;

  li { list-style: none; text-align: center; }
  a {
    display: inline-block;
    padding: 8px 16px;
    border-radius: 10px;
    text-decoration: none;
    color: rgba(255, 255, 255, 0.9);
    font-weight: 500;
    transition: all 0.2s ease;
    position: relative;
    
    &::after {
      content: '';
      position: absolute;
      bottom: 0;
      left: 50%;
      transform: translateX(-50%);
      width: 0;
      height: 2px;
      background: linear-gradient(90deg, #00BCD4, #00E5FF);
      transition: width 0.2s ease;
    }
  }
  a:hover { 
    background: rgba(0, 188, 212, 0.1); 
    transform: translateY(-1px);
    color: #00E5FF;
    text-decoration: none;
    
    &::after {
      width: 80%;
    }
  }

  @media screen and (max-width: 800px) {
    grid-template-columns: repeat(4, minmax(0, 1fr));
  }
`;

export const LoginSectionStyled = styled.div`
  display: flex;
  gap: 16px;
  justify-content: flex-end;
  align-items: center;

  @media screen and (max-width: 800px) {
    justify-content: center;
  }
`;

export const ButtonStyled = styled.button`

`;

export const PrimaryButtonStyled = styled(ButtonStyled)`

`;

export const BigPromoStyled = styled.section`
  width: 1000px;
  max-width: 100%;
  margin: 48px auto 0;
  padding: 24px 12px 0;

  h1 {
    font-size: clamp(42px, 6vw, 72px);
    text-align: center;
    margin: 0;
    line-height: 1.15;
    font-weight: 800;
    letter-spacing: -0.02em;
    color: rgba(255, 255, 255, 0.95);
    text-shadow: 0 2px 20px rgba(0, 188, 212, 0.2);
    animation: fadeInUp 0.8s ease-out;
  }

  h2 {
    text-align: center;
    margin: 24px auto 0;
    font-size: clamp(18px, 2.4vw, 24px);
    font-weight: 400;
    opacity: 0.85;
    max-width: 850px;
    line-height: 1.6;
    animation: fadeInUp 0.8s ease-out 0.2s both;
  }

  .start-for-free-wrapper {
    text-align: center;
    margin: 48px 0 60px;
    animation: fadeInUp 0.8s ease-out 0.4s both;
  }
  
  @keyframes fadeInUp {
    from {
      opacity: 0;
      transform: translateY(30px);
    }
    to {
      opacity: 1;
      transform: translateY(0);
    }
  }
`;

export const DashboardImageStyled = styled.div`
  animation: fadeInUp 0.8s ease-out 0.6s both;
  
  img {
    width: 100%;
    border-radius: 16px;
    box-shadow: 0 20px 60px rgba(0, 188, 212, 0.2), 
                0 8px 24px rgba(0, 0, 0, 0.4);
    transition: transform 0.3s ease, box-shadow 0.3s ease;
    border: 1px solid rgba(0, 188, 212, 0.2);
  }
  
  img:hover {
    transform: translateY(-8px) scale(1.01);
    box-shadow: 0 30px 80px rgba(0, 188, 212, 0.3), 
                0 12px 32px rgba(0, 0, 0, 0.5);
  }
  
  @keyframes fadeInUp {
    from {
      opacity: 0;
      transform: translateY(30px);
    }
    to {
      opacity: 1;
      transform: translateY(0);
    }
  }
`;

export const FeaturesStyled = styled.section`
  margin: 100px 0;

  h3 {
    font-size: 48px;
    text-align: center;
    font-weight: 700;
    background: linear-gradient(135deg, #ffffff 0%, rgba(255, 255, 255, 0.7) 100%);
    -webkit-background-clip: text;
    -webkit-text-fill-color: transparent;
    background-clip: text;
    margin-bottom: 60px;
    letter-spacing: -0.02em;
  }
`;

export const UptimeStyled = styled.section`
  margin: 100px 0;

  h3 {
    font-size: 48px;
    text-align: center;
    font-weight: 700;
    background: linear-gradient(135deg, #ffffff 0%, rgba(255, 255, 255, 0.7) 100%);
    -webkit-background-clip: text;
    -webkit-text-fill-color: transparent;
    background-clip: text;
    margin-bottom: 30px;
    letter-spacing: -0.02em;
  }
  
  h4{
    text-align: center;
    font-size: 22px;
    margin: 18px 0 10px;
    opacity: 0.9;
  }
  
  .ldoa{
    img{
      max-width: 100%;
      border-radius: 12px;
      box-shadow: 0 8px 32px rgba(0, 0, 0, 0.3);
    }
  }
`;


export const FeatureItemStyled = styled.div`
  margin: 50px 0 100px;
  padding: 32px;
  background: rgba(255, 255, 255, 0.02);
  border-radius: 20px;
  border: 1px solid rgba(0, 188, 212, 0.1);
  transition: all 0.3s ease;

  &:hover {
    background: rgba(255, 255, 255, 0.04);
    border-color: rgba(0, 188, 212, 0.3);
    transform: translateY(-4px);
    box-shadow: 0 12px 48px rgba(0, 188, 212, 0.15);
  }

  h4 {
    text-align: center;
    font-size: 28px;
    margin-bottom: 24px;
    font-weight: 600;
    color: rgba(255, 255, 255, 0.95);
  }

  img {
    max-width: 100%;
    border-radius: 12px;
    box-shadow: 0 8px 32px rgba(0, 0, 0, 0.3);
  }
`;

export const PricingStyled = styled.section`

`;

export const ContactUsStyled = styled.section`
  margin: 120px 0 40px;

  h3 {
    font-size: 48px;
    text-align: center;
    font-weight: 700;
    background: linear-gradient(135deg, #ffffff 0%, rgba(255, 255, 255, 0.7) 100%);
    -webkit-background-clip: text;
    -webkit-text-fill-color: transparent;
    background-clip: text;
    letter-spacing: -0.02em;
  }

  .subtitle {
    text-align: center;
    margin: 16px auto 48px;
    font-size: 18px;
    opacity: 0.8;
    max-width: 700px;
  }

  .contact-grid {
    display: grid;
    grid-template-columns: repeat(2, minmax(0, 1fr));
    gap: 24px;
    margin: 0 auto;
    max-width: 900px;
    
    @media screen and (max-width: 600px) {
      grid-template-columns: 1fr;
    }
  }

  .card {
    display: grid;
    align-content: center;
    gap: 12px;
    padding: 32px 24px;
    border: 1px solid rgba(0, 188, 212, 0.2);
    border-radius: 16px;
    text-decoration: none;
    color: inherit;
    background: linear-gradient(135deg, rgba(0, 188, 212, 0.08) 0%, rgba(0, 188, 212, 0.02) 100%);
    transition: all 0.3s ease;
    position: relative;
    overflow: hidden;
    
    &::before {
      content: '';
      position: absolute;
      top: 0;
      left: 0;
      right: 0;
      height: 3px;
      background: linear-gradient(90deg, #00BCD4, #00E5FF);
      transform: scaleX(0);
      transition: transform 0.3s ease;
    }
  }

  .card:hover {
    transform: translateY(-6px);
    border-color: rgba(0, 188, 212, 0.5);
    box-shadow: 0 16px 48px rgba(0, 188, 212, 0.2);
    background: linear-gradient(135deg, rgba(0, 188, 212, 0.12) 0%, rgba(0, 188, 212, 0.04) 100%);
    
    &::before {
      transform: scaleX(1);
    }
  }

  .card-title { 
    font-weight: 700; 
    font-size: 20px;
    color: rgba(255, 255, 255, 0.95);
  }
  .card-body { 
    opacity: 0.75;
    font-size: 16px;
  }
`;

export const FaqStyled = styled.section`

`;

export const FaqContentStyled = styled.div`
  h3 {
    font-size: 48px;
    text-align: center;
    font-weight: 700;
    background: linear-gradient(135deg, #ffffff 0%, rgba(255, 255, 255, 0.7) 100%);
    -webkit-background-clip: text;
    -webkit-text-fill-color: transparent;
    background-clip: text;
    margin-bottom: 48px;
    letter-spacing: -0.02em;
  }
`;

export const FaqListStyled = styled.div`
  margin: 32px 0;
  text-align: center;
  max-width: 900px;
  margin-left: auto;
  margin-right: auto;
`;

export const FaqListItemStyled = styled.div`
  margin: 24px 0;
  padding: 28px;
  background: rgba(255, 255, 255, 0.02);
  border-radius: 16px;
  border: 1px solid rgba(0, 188, 212, 0.1);
  transition: all 0.3s ease;
  text-align: left;

  &:hover {
    background: rgba(255, 255, 255, 0.04);
    border-color: rgba(0, 188, 212, 0.2);
    transform: translateX(4px);
  }

  .title {
    font-size: 22px;
    font-weight: 600;
    color: rgba(255, 255, 255, 0.95);
    margin-bottom: 12px;
  }

  .body {
    word-break: break-word;
    white-space: pre-wrap;
    overflow-wrap: break-word;
    margin: 0;
    line-height: 1.7;
    opacity: 0.85;
    font-size: 16px;
  }
`;

export const SupportsStyled = styled.section`
  margin: 100px 0;

  h3 {
    font-size: 48px;
    text-align: center;
    font-weight: 700;
    background: linear-gradient(135deg, #ffffff 0%, rgba(255, 255, 255, 0.7) 100%);
    -webkit-background-clip: text;
    -webkit-text-fill-color: transparent;
    background-clip: text;
    margin-bottom: 20px;
    letter-spacing: -0.02em;
  }

  h4 {
    text-align: center;
    font-size: 20px;
    margin: 10px;
    opacity: 0.8;
  }

  .supports-wrap {
    display: grid;
    grid-template-columns: repeat(3, 120px);
    align-items: center;
    justify-items: center;
    justify-content: center;
    gap: 32px;
    margin: 48px auto;
    width: fit-content;
    
    @media screen and (max-width: 600px) {
      grid-template-columns: repeat(3, 100px);
      gap: 24px;
    }
  }

  .icon-ez {
    padding: 24px;
    //background: rgba(255, 255, 255, 0.03);
    border-radius: 16px;
    //border: 1px solid rgba(0, 188, 212, 0.1);
    transition: all 0.3s ease;
    
    &:hover {
      //background: rgba(255, 255, 255, 0.06);
      //border-color: rgba(0, 188, 212, 0.3);
      transform: translateY(-4px) scale(1.05);
      //box-shadow: 0 8px 32px rgba(0, 188, 212, 0.2);
    }
    
    svg {
      width: 80px;
      height: 80px;
      //filter: drop-shadow(0 4px 8px rgba(0, 0, 0, 0.3));
      
      @media screen and (max-width: 600px) {
        width: 60px;
        height: 60px;
      }
    }
  }
`;
